$(function(){

	// console.log('tabs is ready');

	// tabs
	$('.tab_container').find('.tab').hide();

	$('.tab_container').each(function(key) {
		var _self = this;
		 $(_self).find('.tab_wrapper > .tab').each(function(index) {
	 		var cIndex = index + 1;
	 		$(this).attr('id','tab_' + (key+1) + '_' + cIndex);

	 		if ( cIndex == 1 ){
	 			$(this).show();
	 		}
	 	});

		$(_self).find('.tabs li').each(function(index){
			var cIndex = index + 1;
			$(this).attr('data-tab','tab_' + (key+1) + '_' + cIndex);

			if ( cIndex == 1 ){
				$(this).addClass('active_tab');
			}
		});

		$(_self).find('.tabs li').click(function(){
			var tabId = $(this).data('tab');
			$(_self).find('.tab_wrapper > .tab').hide();
			$('#'+tabId).show();
			$(_self).find('.tabs li').removeClass('active_tab');
			$(this).addClass('active_tab');
		});

	});


});
